export default __webpack_public_path__ + "static/media/Ec.aa2b0882.svg";